__turbopack_context__.v({
  "container": "SortMenu-module-scss-module__0DRTnW__container",
  "selectOverlay": "SortMenu-module-scss-module__0DRTnW__selectOverlay",
});
